import styled from 'styled-components'
import { Box, Card, Stack } from '@lojinha/design-system'

export const ThickerCard = styled(Card)(
  ({ theme }) => `
    border: 2px solid ${theme.colors.gray200}; 
  `
)

export const TextContainer = styled(Box)(
  ({ theme }) => `
    padding-right: ${theme.space.x16};

    ${theme.media.below('sm')} {
      padding-right: 0;
    }
  `
)

export const Container = styled(Stack)(
  ({ theme }) => `
    ${theme.media.above('md')}{
      justify-content: flex-end;
    }
  `
)
